<div class="custom-dropdown" [ngClass]="{class: true, opened: isDropdownOpen}">
  <div
    class="selected-option"
    [ngClass]="{ 'placeholder': !selectedOption, 'selected': selectedOption?.value }"
    (click)="toggleDropdown()"
    (keydown)="onDropdownKeyDown($event)"
    tabindex="0"
    role="combobox"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isDropdownOpen"
  >
    <span>
      {{ showSelectedOptionAndPlaceholder ? (placeholder + ' ' + (selectedOption?.name || '')) : (selectedOption?.name || placeholder) }}
    </span>  
    <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
  </div>
  <ul
    class="dropdown-list"
    [ngClass]="optionsContainerClass"
    *ngIf="isDropdownOpen"
    role="listbox"
    [attr.aria-activedescendant]="selectedOption?.value"
    #dropdownList
  >
    <li
      *ngFor="let option of dropdownOptions"
      [ngClass]="{
        'selected': option.value === selectedOption?.value,
        'option': true,
        'options-class': true,
        'selected-option-class': option.value === selectedOption?.value
      }"
      (click)="onSelect(option)"
      role="option"
      [attr.aria-selected]="option.value === selectedOption?.value"
      [attr.id]="option.value"
      tabindex="-1"
    >
      {{ option.name }}
    </li>
  </ul>
</div>
